module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAABroNZJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEDSURBVHgB7ZTfDYIwEMavTXl3AzuCbuAIuoEjYIDwqO9A0hXcQCfQERihboDP/POrUWMQKEEf/ZKml+vll971eowg13Un2MyySimlmz4WhqGs6/qEJWmY5lEUpe8OURTFjHMuYacAHWwExOumTwBwT6OqKpUkyZ5GSDQdQRCsGWNbGiDc/Jzn+eYDYgCP+mgLw2SwdhwnFS10ie2A4q36CJ7nLVAK8yAT3hGTkUVCCP20Of1Af0gLBJ2qjYH+sL5IJwStfgZIxnF8pJG6pwPQhb7Q6Jrg9q/5Izpilr7va+oRajhDy7dDcKhw6GLf9UEegAzzZc/aAvC5pjRAZVleMS6zG5/BaOGg3mVqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/copy.png
// module id = 1745
// module chunks = 0